var rtl_rtlignore_default = {
  "rtl": "UuWd-",
  "ltr": "uqRv7"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
